@let editingSegment = store.editingSegmentSg();

<div class="atn-page-segment-dialog-general-tab">
  <atn-ds-text
    label="Name"
    placeholder="Enter a name"
    [value]="editingSegment?.name"
    (change)="nameChangeHandler($event)"
  ></atn-ds-text>
  <atn-ds-text
    label="Alias"
    placeholder="Enter an alias"
    [value]="editingSegment?.alias"
    (change)="aliasChangeHandler($event)"
  ></atn-ds-text>
</div>
